import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { testimonialOptions, Testimoninal } from '../../../../components/testimoninal/testimoninal';

interface CompetitorTestimoninalProps {
  testimoninalTitle: React.ElementType;
  testimoninalSubTitle: React.ElementType;
}

export function CompetitorTestimoninal({
  testimoninalTitle: TestimoninalTitle,
  testimoninalSubTitle: TestimoninalSubTitle,
}: CompetitorTestimoninalProps) {
  // const theme = useTheme();

  const businessTestimoninalConfig = [
    {
      children: testimonialOptions.pet_palace,
      color: '#f5c14f',
    },
    {
      children: testimonialOptions.whitegates_grooming,
      color: '#f86e6a',
    },
    {
      children: testimonialOptions.groomed_by_nic,
      color: '#90cfd1',
    },
    {
      children: testimonialOptions.mias_paw_spa,
      color: '#f5a046',
    },
    {
      children: testimonialOptions.pawfect_place,
      color: '#8cc4b8',
    },
  ];

  return (
    <WidthContainer>
      <SectionContainer title={TestimoninalTitle} subTitle={TestimoninalSubTitle}>
        <Testimoninal testimonialConfig={businessTestimoninalConfig} />
      </SectionContainer>
    </WidthContainer>
  );
}
